function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 21c4.411 0 8-3.589 8-8 0-3.35-2.072-6.221-5-7.411v2.223A6 6 0 0117 13c0 3.309-2.691 6-6 6s-6-2.691-6-6a6 6 0 013-5.188V5.589C5.072 6.779 3 9.65 3 13c0 4.411 3.589 8 8 8z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 2h2v10h-2V2z"
});
function SvgPowerOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref, _ref2);
}
export default SvgPowerOff;